import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';

class Component extends BaseComponent {
    componentWillMount() {
        this.props.requireContent(this.props.tag);
    }

    render({ header, nodes, url }) {
        return (
            <nav-articles>
                <a href={url}><h2>{header}</h2></a>
                <ul>{(nodes || []).map(this.renderNode)}</ul>
            </nav-articles>
        );
    }

    renderNode = (node, i) => {
        const image_src = node.picture_frag
            ? `https://gfx.tarot.com/images/feeds/380x235/${node.picture_frag}-380x235.jpg`
            : '';

        return (
            <li>
                <a
                  href={node.url}
                  onClick={() => this.trackClick(`${this.props.category} - Featured Article #${i + 1}`)}
                >
                    <figure>
                        <img
                          src={image_src}
                          alt={node.image_alt}
                        />
                    </figure>
                    <div>
                        <h3>{node.title}</h3>
                        <p>{node.subtitle}<span> … Read More</span></p>
                    </div>
                </a>
            </li>
        );
    }

    trackClick = (label) => {
        const action = this.props.logged_in ? 'LI Click' : 'LO Click';

        this.props.trackEvent(['Navigation', action, label]);
    }
}

const mapStateToProps = (state, { tag }) => ({
    nodes: state.content && state.content.nav && state.content.nav[tag],
    logged_in: state.user && state.user.logged_in,
});

const mapDispatchToProps = (dispatch) => ({
    requireContent: (tag) => dispatch({ type: 'content:fetchNav', payload: tag }),
    trackEvent: (payload) => dispatch({ type: 'ga:event', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);



// WEBPACK FOOTER //
// ./app/components/nav-articles.js